export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./load-more.vue?vue&type=template&id=4c286c80&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/load-more/load-more.vue?vue&type=template&id=4c286c80&
// module id = 993
// module chunks = 0